import type { PublishPreflightResponse } from '../api/posts'
import type { PublishReadinessPreflightResponse } from '../api/posts'

export function getPreflightFailureMessage(preflight: PublishPreflightResponse): string | null {
  if (preflight.status !== 'fail') return null
  const failedChecks = (preflight.checks || []).filter((c) => c.status === 'fail').map((c) => c.name).join(', ')
  if (failedChecks) {
    return `Publish checks failed: ${failedChecks}. Please retry in a moment.`
  }
  return 'Publish checks failed. Please retry in a moment.'
}

export function getReadinessBlockingMessage(preflight: PublishReadinessPreflightResponse): string | null {
  const blocking = preflight.blocking || []
  if (!blocking.length) return null
  return blocking.map((b) => b.message).join(' ')
}
